import React from 'react'
import PanelPricing from '../Components/Pricing/PanelPricing'
import Break from '../Components/Ornaments/Break'

export default function Panels() {
  return (
    <div id="panel-pricing">
        <PanelPricing/>
        <Break/>
    </div>
  )
}
